import { createPalette } from '../../palette'
import { type TenantPaletteConfig } from '../types'

/**
 * DHL tenant palette — uses the canonical DHL light and dark palettes.
 */
export const dhlPalette: TenantPaletteConfig = {
  light: createPalette('light'),
  dark: createPalette('dark'),
}
